import React from 'react';
import { MotionImage, FadeInSection } from '../ui/MotionPrimitives';

const AboutUs: React.FC = () => {
  return (
    <FadeInSection className="w-full bg-white py-14 md:py-20">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-10 px-6 md:flex-row md:items-stretch md:gap-14 md:px-10">
        {/* Image column */}
        <div className="w-full md:w-1/2 -mt-[21px] md:-mt-[25px]">
          <div className="h-96 w-full overflow-hidden rounded-[32px] bg-gray-200 shadow-[0_22px_45px_rgba(15,23,42,0.16)] md:h-[500px]">
            <MotionImage
              src="/images/pics/homeaboutimg.png"
              alt="Modern property exterior"
              className="h-full w-full object-cover"
            />
          </div>
        </div>

        {/* Text column */}
        <div className="w-full md:w-1/2">
          <p className="text-sm font-semibold uppercase tracking-[0.16em] text-[#D88546]">
            About Us
          </p>
          <h3 className="mt-3 text-[26px] font-semibold text-black md:text-[32px] lg:text-[36px]">
            Hogar Dorado House:
          </h3>
          <p className="mt-1 text-lg font-medium text-black md:text-xl">
            Global Real Estate Investment and Advisory
          </p>

          <div className="mt-6 space-y-4 text-sm leading-relaxed text-black/70 md:text-base">
            <p>
              Hogar Dorado House is a specialized real estate investment firm bringing over five years
              of proven experience in the dynamic markets of the United Arab Emirates (UAE) and the
              United States of America (USA). With a deep commitment to excellence and a strong track
              record of success, we are dedicated to creating lasting value for our clients, partners,
              and team members through strategic property acquisition, development, and management.
            </p>
            <p>
              Our commitment is to leverage deep market intelligence and a robust network to deliver
              exceptional returns and enduring value for our clients, partners, and stakeholders.
            </p>
          </div>
        </div>
      </div>
    </FadeInSection>
  );
};

export default AboutUs;
